import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import Popup from '../Popup';
import s from './HistoryListPopUp.css';
import HistoryDocuments from '../HistoryDocuments';
import Picker from './Picker';
import HistoryAlarms from '../HistoryAlarms';
import Loader from '../Loader';
import ListContainer from './ListContainer';
import Messages from './Messages';
import Button from '../Button';
import Icon from '../Icon';

class HistoryListPopupView extends React.Component {

  downloadPicker = (messages, intl) => {
    return (
      <div className={s.pickerStyled}>
        <Picker
          title={intl.formatMessage({ 
            ...messages.from_date_history_text })
          }
          start={'start'}
          fromParentToChildCallback={this.props.fromParentToChildCallback}
        />
        <Picker
          title={intl.formatMessage({ ...messages.to_date_history_text })}
          start={'stop'}
          fromParentToChildCallback={this.props.fromParentToChildCallback}
        />
      </div>
    )
  }

  downloadFooter = (
    messages,
    intl,
    deviceType,
    historyDownloadInProgress,
    historyDownloadFailed,
    filterConnect,
  ) => {
    const iconSize = 41;
    const isSuperior = deviceType === 'superior';
    const buttonStyle = isSuperior ? cx(s.blackButton) : cx(s.whiteButton);
    const downloadIcon = isSuperior ? 'pobierz' : 'pobierz_white';
    const dark = isSuperior ? 'dark_spirotech' : 'dark';
    if (filterConnect === 'online') {
      if (!historyDownloadInProgress) {
        return (
          <div>
            {historyDownloadFailed ? (
              <div className={s.historyFailed}>
                <FormattedMessage {...messages.history_download_failed} />
              </div> ) : null}
            {this.downloadPicker(messages, intl)}
            <div className={s.marginLeft}>
              <Button
                onClick={() => {
                  this.props.onDownload();
                }}
                buttonClass="mainPdf"
                buttonColor={dark}
              >;
                <Icon iconName={downloadIcon} size={iconSize} />
                <div className={buttonStyle}>
                  <FormattedMessage {...messages.download_history_text} />
                </div>
              </Button>
              {deviceType === 'superior' ? (
                <Button
                  onClick={() => {
                    this.props.onPulseMaskDownload();
                  }}
                  buttonClass="mainPdf"
                  buttonColor={dark}
                >
                  <Icon iconName={downloadIcon} size={iconSize} />
                  <div className={buttonStyle}>
                    <FormattedMessage
                      {...messages.download_pressure_log_text}
                    />
                  </div>
                </Button>
                ) : null }
              </div>
          </div>
        );
      }
      const tmpFilesToDownload = this.props.filesToDownloadValue - this.props.filesToDownload;
      const filesCountLabel = `${tmpFilesToDownload}/${this.props.filesToDownloadValue}`;
      return (
        <div>
          <div className={s.historyDownloading}>
            <FormattedMessage {...messages.files_count_downloaded} /> {filesCountLabel}
          </div>
          <Loader block />
        </div>
      );
    }
    return null;
  };

  render() {
    const {
      intl,
      deviceType,
      serial,
      historyDownloadInProgress,
      historyDownloadFailed,
      deviceDocumentsPaging,
      devicePaging,
      deviceName
    } = this.props;
    const messages = Messages();

    const footerArguments = [
      messages,
      intl,
      deviceType,
      historyDownloadInProgress,
      historyDownloadFailed,
      devicePaging.get('filterConnect'),
    ];
    if (this.props.deviceDocumentsPaging.get('loaded')) {
      if (this.props.deviceDocuments.size) {
        return (
          <Popup
            className={s.Popup__editdevice}
            onClose={this.props.onClose}
            devicetype={deviceType}
            overrideOnClose
          >
            <ListContainer>
              <HistoryDocuments
                getNextDocumentsPage={this.props.getNextDocumentsPage}
                getDeviceDocumentsList={this.props.getDeviceDocumentsList}
                newFilesDownloaded={this.props.newFilesDownloaded}
                deviceType={deviceType}
                deviceName={deviceName}
                serial={serial}
              />
            </ListContainer>
            {this.downloadFooter(...footerArguments)}
            <ListContainer>
              <HistoryAlarms getNextAlertPage={this.props.getNextAlertPage} />
            </ListContainer>
          </Popup>
        );
      }
      return (
        <Popup
          className={s.Popup__editdevice}
          onClose={this.props.onClose}
          overrideOnClose
        >
          <FormattedMessage {...messages.no_files_text} />
          {this.downloadFooter(...footerArguments)}
          <ListContainer>
            <HistoryAlarms getNextAlertPage={this.props.getNextAlertPage} />
          </ListContainer>
        </Popup>
      );
    }
    return (
      <Popup
        className={s.Popup__editdevice}
        onClose={this.props.onClose}
        overrideOnClose
      >
        <Loader block />
        {this.downloadFooter(...footerArguments)}
        <ListContainer>
          <HistoryAlarms getNextAlertPage={this.props.getNextAlertPage} />
        </ListContainer>
      </Popup>
    );
  }
}

HistoryListPopupView.propTypes = {
  serial: PropTypes.string.isRequired,
  deviceName: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  deviceDocuments: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  deviceDocumentsPaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onClose: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  onPulseMaskDownload: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  fromParentToChildCallback: PropTypes.func.isRequired,
  getNextAlertPage: PropTypes.func.isRequired,
  getNextDocumentsPage: PropTypes.func.isRequired,
  historyDownloadInProgress: PropTypes.bool.isRequired,
  historyDownloadFailed: PropTypes.bool.isRequired,
  filesToDownload: PropTypes.number.isRequired,
  filesToDownloadValue: PropTypes.number.isRequired,
  devicePaging: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  newFilesDownloaded: PropTypes.arrayOf(PropTypes.number).isRequired,
  getDeviceDocumentsList: PropTypes.func.isRequired,
};

export default injectIntl(withStyles(s)(HistoryListPopupView));



// WEBPACK FOOTER //
// ./src/components/HistoryListPopUp/HistoryListPopUpView.js